module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/umeda_concept_03-9cc5e9d2462c15b0d3f718d85cee7eab.jpg";